import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const Founder: React.FC = () => {
  const { data, isRTL } = useLanguage();
  const founderData = data.founder;

  if (!founderData?.active) return null;

  return (
    <section id="founder" className="py-20 bg-gradient-to-br from-purple-900 via-purple-800 to-indigo-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-20 w-32 h-32 bg-gradient-to-r from-orange-400 to-pink-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-20 w-40 h-40 bg-gradient-to-r from-blue-400 to-purple-500 rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">{founderData.title}</h2>
        </div>

        <div className="max-w-6xl mx-auto">
          <div className={`flex flex-col lg:flex-row items-center gap-12 ${isRTL ? 'lg:flex-row-reverse' : ''}`}>
            <div className="lg:w-1/3 flex justify-center">
              <div className="relative">
                <div className="w-64 h-64 rounded-full overflow-hidden border-4 border-white/20 shadow-2xl">
                  <img
                    src={founderData.image}
                    alt={founderData.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="absolute -top-4 -right-4 w-8 h-8 bg-gradient-to-r from-orange-400 to-pink-500 rounded-full"></div>
                <div className="absolute -bottom-4 -left-4 w-6 h-6 bg-gradient-to-r from-blue-400 to-purple-500 rounded-full"></div>
              </div>
            </div>

            <div className="lg:w-2/3 text-center lg:text-left">
              <div className="mb-8">
                <h3 className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-orange-400 via-pink-500 to-purple-400 bg-clip-text text-transparent mb-2">
                  {founderData.name}
                </h3>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
                <p className="text-white/90 text-lg leading-relaxed">
                  {founderData.description}
                </p>
              </div>

              <div className="flex justify-center lg:justify-start gap-2 mt-6">
                <div className="w-3 h-3 bg-gradient-to-r from-orange-400 to-pink-500 rounded-full"></div>
                <div className="w-3 h-3 bg-gradient-to-r from-pink-500 to-purple-500 rounded-full"></div>
                <div className="w-3 h-3 bg-gradient-to-r from-purple-500 to-blue-500 rounded-full"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Founder;